/**
 * Open/close state for the hosted Add Project dialog.
 *
 * Add Project has several entry points (command palette action, sidebar button,
 * empty-state button) that all funnel through the command palette, so the
 * hosted branch is taken there once and this store carries the request to the
 * dialog host mounted alongside the app's other global dialogs.
 */
import { create } from "zustand";

interface HostedAddProjectStore {
  readonly open: boolean;
  readonly requestOpen: () => void;
  readonly setOpen: (open: boolean) => void;
}

export const useHostedAddProjectStore = create<HostedAddProjectStore>((set) => ({
  open: false,
  requestOpen: () => set({ open: true }),
  setOpen: (open) => set({ open }),
}));

export function openHostedAddProjectDialog(): void {
  useHostedAddProjectStore.getState().requestOpen();
}
